import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { Add, ExpandMore } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { providerSuperviseeRoute, ROUTING_CONFIG } from '@uplift/constants';
import { useProviderSuperviseeQuery } from '@uplift/queries';
import { Button, Loader, Menu, MenuItem, ProviderLayout, ScrollableView, SupervisionMeetingDetailModal } from '@uplift/ui-v2';

import { ActivityFeed } from './components/ActivityFeed';
import { SuperviseeDetails } from './components/SuperviseeDetails';
import { SupervisionMeetingFormModal } from './components/SupervisionMeetingFormModal';


export const SuperviseeDetailsPage: React.VFC = () => {
  const { superviseeId } = providerSuperviseeRoute.useParams();
  const { data: superviseeMatch, isLoading } = useProviderSuperviseeQuery(superviseeId);
  const [meetingModalOpen, setMeetingModalOpen] = useState(false);
  const [selectedMeetingId, setSelectedMeetingId] = useState<string | null>(null);

  if (isLoading) {
    return (
      <ProviderLayout>
        <Loader />
      </ProviderLayout>
    );
  }

  if (!superviseeMatch) {
    return <Redirect to={ROUTING_CONFIG.supervisees} />;
  }

  return (
    <ProviderLayout>
      <Box sx={{ display: 'flex', minHeight: '100vh' }}>
        <Box sx={{ width: 420, borderRight: 1, borderColor: 'divider', backgroundColor: 'background.paper' }}>
          <SuperviseeDetails superviseeId={superviseeId} />
        </Box>
        <ScrollableView>
          <Box sx={{ p: '48px 40px', display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h5" fontWeight={450}>Activity</Typography>
              <Menu
                renderAnchor={({ onClick }) => (
                  <Button variant="contained" color="secondary" startIcon={<Add />} endIcon={<ExpandMore />} onClick={onClick}>
                    Add Activity
                  </Button>
                )}
              >
                <MenuItem onClick={() => setMeetingModalOpen(true)}>
                  Supervision Meeting
                </MenuItem>
              </Menu>
            </Box>
            <ActivityFeed superviseeId={superviseeId} onSelectMeeting={setSelectedMeetingId} />
          </Box>
        </ScrollableView>
      </Box>
      <SupervisionMeetingFormModal
        open={meetingModalOpen}
        onClose={() => setMeetingModalOpen(false)}
        superviseeId={superviseeId}
      />
      <SupervisionMeetingDetailModal
        open={!!selectedMeetingId}
        onClose={() => setSelectedMeetingId(null)}
        meetingId={selectedMeetingId}
        superviseeMatch={superviseeMatch}
      />
    </ProviderLayout>
  );
};
